var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.08624 8.48136C7.77944 8.77524 7.77944 9.25171 8.08624 9.54558C8.39303 9.83946 8.89044 9.83946 9.19724 9.54558L13.3871 5.53215C13.5405 5.38521 13.6172 5.19262 13.6172 5.00003C13.6172 4.898 13.596 4.80071 13.5576 4.71198C13.5192 4.62323 13.4624 4.54007 13.3871 4.46792L9.19724 0.454484C8.89044 0.160607 8.39303 0.160607 8.08624 0.454484C7.77944 0.748362 7.77944 1.22483 8.08624 1.51871L10.935 4.24751L0.785763 4.24752C0.35189 4.24752 0.000165486 4.58443 0.000165523 5.00004C0.000165559 5.41564 0.35189 5.75255 0.785763 5.75255L10.935 5.75255L8.08624 8.48136Z",
    fill: "#735BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleRightArrow);
export default __webpack_public_path__ + "static/media/purpleRightArrow.3a922dcaca940613c87ef4440d0e8d42.svg";
export { ForwardRef as ReactComponent };